export class SensorAccessory {
    id: number;
    name: string;
    nc12: string;
    eoc: string;
    description: string;
    type: any;
    sensorApplications: any;
}



// WEBPACK FOOTER //
// ./src/app/_models/sensor_accessory.ts